import { createSlice } from '@reduxjs/toolkit';

/* const initialState = {
     firstName: "sasa",
    lastName: "sasa",
    countryCode: "Afghanistan",
    mobileNum: "11111111",
    email: "sasara@grensesnitt.com",
    primary: "yes"
}; */
 
const initialState = {};

const yourInfoSlice = createSlice({
    name: "yourInformation",
    initialState,
    reducers: {
        yourInfoAdded(state, action) {         
            return {
				...state,
				firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                countryCode: action.payload.countryCode,
                mobileNum: action.payload.mobileNum,
                email: action.payload.email,
                primary: action.payload.primary
			};
        },
        yourInfoAddedPrimaryContractLinked(state, action) {
            return {
				...state,
				firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                countryCode: action.payload.countryCode,
                mobileNum: action.payload.mobileNum,
                email: state.email,
                primary: action.payload.primary
			};
        }
    }
});

export const yourInformationSelector = (state) => state.yourInformation;

export const { yourInfoAdded, yourInfoAddedPrimaryContractLinked } = yourInfoSlice.actions
export default yourInfoSlice.reducer
